<template>
    <Layout no-header :content-class="'login-page'">
        <div class="login-page__inner">
            <Logo class="login-page__logo" width="210" height="35" />
            <div class="login-form">
                <p v-if="!code">Invalid invite link! Please request a new invite link.</p>

                <CustomersInviteForm v-else :code="code" />
            </div>
        </div>
    </Layout>
</template>

<script>
import Logo from '@speechki-frontend/shared/ui/layout/Logo';
import Layout from '@speechki-frontend/shared/ui/layout/Layout';

import { CustomersInviteForm } from '../../components';

export default {
    name: 'CustomersInvitePage',
    components: {
        Logo,
        Layout,
        CustomersInviteForm,
    },

    computed: {
        code() {
            return this.$route.query.id;
        },
    },
};
</script>
